import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const TABLE_BODY_ROW_CLASS_NAME = 'TableBodyRow';

export const TABLE_BODY_ROW_CLASS_SLOTS = ['root'] as const;

export type TableBodyRowClassSlot = (typeof TABLE_BODY_ROW_CLASS_SLOTS)[number];

export interface TableBodyRowClasses {
	root: string;
	isClickable: string;
	isDragGhost: string;
	isDragging: string;
	isEngaged: string;
	isSelected: string;
	shifted: string;
}

export type TableBodyRowClassKey = keyof TableBodyRowClasses;

export const getTableBodyRowUtilityClass = (slot: string) =>
	generateUtilityClass(TABLE_BODY_ROW_CLASS_NAME, slot);

export const tableBodyRowClasses = generateUtilityClasses<
	keyof TableBodyRowClasses
>(TABLE_BODY_ROW_CLASS_NAME, [
	'root',
	'isClickable',
	'isDragGhost',
	'isDragging',
	'isEngaged',
	'isSelected',
	'shifted',
]);
export default tableBodyRowClasses;
